import React from "react";
import { Box, Button, FormControlLabel, Switch } from "@mui/material";
import { ScraperConfig } from "./types";
import ConfigValuesList from "./ConfigValuesList";
import { useAdminPanelContext } from "../../context/AdminPanelContext";
import { confirmAlert } from "react-confirm-alert";
import NewConfigForm from "./NewConfigForm";

enum ConfigOption {
	SUBJECT = "subject",
	QUERY = "query",
	SEARCH_TERM = "searchterm",
}

enum Action {
	UPDATE = "Update",
	DELETE = "Delete",
}

export interface ConfigPanelListProps {
	item: ScraperConfig;
}

const ConfigPanelList: React.FC<ConfigPanelListProps> = ({ item: config }) => {
	const { handleConfigs } = useAdminPanelContext();
	const searchTerms = config?.scraperConfigOptions?.find(
		(o) => o.name === ConfigOption.SEARCH_TERM
	);

	const submit = (action: Action) => {
		const isDelete = action === Action.DELETE;
		confirmAlert({
			title: isDelete ? "Delete config" : "Update config activity",
			message: isDelete
				? `Are you sure you want to delete config with Id: ${config.id}; and scraperId: ${config.scraper.id}; Scraper: ${config.scraper.type} - ${config.scraper.name}?`
				: `Are you sure you want to change the config with Id: ${
						config.id
				  } to ${config.active ? "inactive" : "active"}`,
			buttons: [
				{
					label: isDelete ? "Delete" : "Update",
					onClick: isDelete
						? () => handleConfigs.delete(config.id)
						: () =>
								handleConfigs.update(
									{ ...config, active: !config.active },
									true
								),
				},
				{
					label: "Cancel",
				},
			],
		});
	};

	return (
		<>
			{config ? (
				<>
					{config.id > 0 ? (
						<Box
							style={{
								height: "calc(100vh - 230px)",
								display: "flex",
								flexDirection: "column",
							}}
						>
							<Box
								sx={{
									padding: 1,
								}}
							>
								<Button
									variant="outlined"
									color="error"
									onClick={() => submit(Action.DELETE)}
								>
									Delete config
								</Button>
								<FormControlLabel
									value="Active"
									control={<Switch color="success" checked={config.active} />}
									onChange={() => submit(Action.UPDATE)}
									label={config.active ? "Active" : "Inactive"}
									labelPlacement="end"
									sx={{ ml: 1 }}
								/>
							</Box>

							{searchTerms ? (
								<Box sx={{ overflowY: "auto", height: "100%" }}>
									<ConfigValuesList
										configOption={searchTerms}
										configId={config.id}
									></ConfigValuesList>
								</Box>
							) : null}
						</Box>
					) : (
						<NewConfigForm config={config} />
					)}
				</>
			) : null}
		</>
	);
};

export default ConfigPanelList;
